import React, { useState, useEffect, useCallback, useRef } from 'react';
import config from '../../config/apiConfig';
// --- CONFIGURACIÓN DE TU API ---
//const API_BASE_URL = 'http://127.0.0.1:5000/api/v1';
const POLLING_INTERVAL = 5000;

// --- Sonido de Alerta (Reemplaza con la ruta a tu archivo .mp3/.wav) ---
const ALERT_SOUND_PATH = '/static/audio/notificacion_pedido_nuevo.mp3';
const audio = new Audio(ALERT_SOUND_PATH);

// 🔑 NUEVO AUDIO PARA PEDIDO LISTO
const READY_ORDER_SOUND_PATH = '/static/audio/notificacion_retiro.mp3';
const audioReadyOrder = new Audio(READY_ORDER_SOUND_PATH); // Audio para "Lista"

/**
 * Custom Hook para gestionar el estado, la carga y el polling de pedidos activos.
 */
const usePedidosKDS = () => {
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isInitialLoad, setIsInitialLoad] = useState(true);


    // Ref para almacenar los IDs de los pedidos de la consulta anterior
    const previousOrderIds = useRef(new Set());

    // 🔑 NUEVA REFERENCIA: IDs de pedidos que ya sonaron como "Listos"
    const readyOrdersSounded = useRef(new Set());


    // 🔑 Modificamos la función de verificación
    const checkNewOrdersAndAlert = (newOrders) => {
        let newOrdersFound = false;
        let readyOrdersFound = false;

        const currentOrderIds = new Set();

        newOrders.forEach(order => {
            currentOrderIds.add(order.id);

            // A. Detección de Pedido Nuevo (Sin cambios)
            // Condición: El ID no existía ANTES Y está en estado 'Recibida'
            if (!previousOrderIds.current.has(order.id) && order.status === 'Recibida') {
                newOrdersFound = true;
            }

            // B. Detección de Pedido Listo (Solo si no ha sonado)
            // Condición: El estado es 'Lista' Y no está en nuestra lista de ya sonados
            if (order.status === 'Lista' && !readyOrdersSounded.current.has(order.id)) {
                readyOrdersFound = true;
                // Marcamos inmediatamente que ya sonó para el siguiente ciclo
                readyOrdersSounded.current.add(order.id);
            }
        });

        // 🔑 EJECUCIÓN 1: Alerta de Pedido Nuevo (AFUERA del forEach)
        if (newOrdersFound) {
            console.log("¡ALARMA! Se detectaron nuevos pedidos recibidos.");
            audio.play().catch(e => console.error("Error al reproducir nuevo pedido:", e));
        }

        // 🔑 EJECUCIÓN 2: Alerta de Pedido Listo (AFUERA del forEach)
        if (readyOrdersFound) {
            console.log("¡LISTO! Se detectaron pedidos que acaban de pasar a LISTA.");
            audioReadyOrder.play().catch(e => console.error("Error al reproducir pedido listo:", e));
        }

        // 🔑 ACTUALIZACIÓN FINAL: Esto lo hacemos justo antes de que termine la función
        previousOrderIds.current = currentOrderIds;
    };

    // Función principal para obtener los pedidos activos desde el Backend
    let url = `${config.api_url}/api/v1/pedidos_activos`;
    const fetchOrders = useCallback(async () => {

        const token = localStorage.getItem("token");
        if (isInitialLoad) { setIsLoading(true); }

        let response; // 🔑 LÍNEA CLAVE: Declarar aquí para que sea visible en todo el ámbito
      
        if (isInitialLoad) { setIsLoading(true); }

        try {
            // Quitaste 'const'/'let' de aquí, porque ya la declaraste arriba
            response = await fetch(url, {
                method: 'GET',
                headers: { 'token': token }
            });


            if (!response.ok) {
                throw new Error(`Error de conexión HTTP: ${response.status}`);
            }

            const data = await response.json();

            console.log("pedidos", data)

            if (Array.isArray(data)) {

                // 1. Lógica de Alerta (Solo se ejecuta si NO es la carga inicial)
                if (!isInitialLoad) {
                    checkNewOrdersAndAlert(data);
                }

                // 🔑 CORRECCIÓN CLAVE: ESTA LÍNEA DEBE EJECUTARSE SIEMPRE
                // Rellena la lista de IDs para que el siguiente ciclo tenga algo con qué comparar.
                previousOrderIds.current = new Set(data.map(o => o.id)); // <-- ¡DEBE IR AQUÍ!

                setOrders(data);
                setError(null);
            }

        } catch (err) {
            console.error("Fallo al obtener pedidos:", err);
            setError(err.message || "Error al conectar con la API de pedidos.");

        } finally {
            setIsLoading(false);
            if (isInitialLoad) { setIsInitialLoad(false); }
        }
    }, [isInitialLoad]);


    // --- EFECTO DE POLLING Y CARGA INICIAL ---
    useEffect(() => {
        fetchOrders();
        const interval = setInterval(() => { fetchOrders(); }, POLLING_INTERVAL);
        return () => clearInterval(interval);
    }, [fetchOrders]);


    return { orders, isLoading, error, fetchOrders};
};

export default usePedidosKDS;